import React, { useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";

export default function PriceList() {
  const navigate = useNavigate();

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 DEMO API (replace later)
  const fetchData = async () => {
    try {
      setLoading(true);

      // 👉 dummy data
      const data = [
        {
          _id: "1",
          Product_Title: "Gold Ring",
          HSN_Code: "7113",
          Purchase_Rate: 5000,
          landedCost: 5200,
          ProfitPercentage: 5,
          SalesRate: 5500,
          lossStatus: false,
          maxDiscount: 10,
          GSTRate: 18,
          Product_MRP: 6500,
        },
        {
          _id: "2",
          Product_Title: "Silver Chain",
          HSN_Code: "7113",
          Purchase_Rate: 2000,
          landedCost: 2100,
          ProfitPercentage: 2,
          SalesRate: 2300,
          lossStatus: true,
          maxDiscount: 8,
          GSTRate: 18,
          Product_MRP: 2700,
        },
      ];

      setRowData(data);
    } catch (err) {
      console.log(err);
      setRowData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // 🔥 Columns
  const columnDefs = [
    {
      headerName: "Product Name",
      field: "Product_Title",
      width: 300,
    },
    {
      headerName: "HSN Code",
      field: "HSN_Code",
      width: 140,
    },
    {
      headerName: "Purchase Rate",
      width: 135,
      valueGetter: (p) =>
        p?.data?.landedCost > p?.data?.Purchase_Rate
          ? p?.data?.landedCost
          : p?.data?.Purchase_Rate,
    },
    {
      headerName: "Profit %",
      width: 100,
      valueGetter: (p) =>
        p?.data?.ProfitPercentage > 3 ? p?.data?.ProfitPercentage : 3,
    },
    {
      headerName: "Sales Rate",
      width: 120,
      cellRenderer: (p) => (
        <span style={{ color: p?.data?.lossStatus ? "red" : "green" }}>
          {p?.data?.SalesRate?.toFixed(2)}
        </span>
      ),
    },
    {
      headerName: "Grade Discount",
      width: 140,
      valueGetter: (p) => p?.data?.maxDiscount,
    },
    {
      headerName: "Tax",
      width: 100,
      field: "GSTRate",
    },
    {
      headerName: "Product MRP",
      width: 130,
      cellRenderer: (p) => (
        <span>{p?.data?.Product_MRP?.toFixed(2)}</span>
      ),
    },
  ];

  // 🔥 Loading
  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="erp-page-grid">

      {/* 🔥 Header */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2>Price List</h2>

        <Button
          color="primary"
          onClick={() =>
            navigate("/production?view=add-product")
          }
        >
          <FaPlus /> Add Product
        </Button>
      </div>

      {/* 🔥 Table */}
      <div
        className="ag-theme-alpine"
        style={{ height: "500px", marginTop: "10px" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          pagination
        />
      </div>
    </div>
  );
}